import React from 'react';
import { Badge } from 'antd';
import { useCustomerContext } from '../../context';
import useAppLocked from '../../hooks/useAppLocked';
import { isOrderBasedTask, isDistributionTask } from '../../utils/taskUtils';
import { theme } from '../../utils/theme';

const TasksBadge = ({ children }) => {
  const { customer } = useCustomerContext();
  const { data, loading } = useAppLocked({
    customer: customer?.id,
    isRemoteVisit: false,
    activityMode: customer?.activityMode,
  });

  if (!customer || loading) return children;

  const regularTasks = (data || []).filter(
    (t) => !isOrderBasedTask(t) && !isDistributionTask(t),
  );

  if (regularTasks.length === 0) return children;

  const total = regularTasks.length;
  const completed = regularTasks.filter((t) => t.isCompleted).length;

  return (
    <Badge
      style={{ marginTop: '6px' }}
      count={
        <span
          style={{
            backgroundColor:
              completed === total ? '#52c41a' : theme.brand.primary,
            color: '#fff',
            fontSize: '10px',
            padding: '0 4px',
            borderRadius: '10px',
            minWidth: '24px',
            height: '16px',
            lineHeight: '16px',
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          {completed}/{total}
        </span>
      }
    >
      {children}
    </Badge>
  );
};

export default TasksBadge;
